// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1qHHG","productName":"Table_productName__2elaq"};